import { render, staticRenderFns } from "./CountryTemplateForm.vue?vue&type=template&id=c0ba76c2&"
import script from "./CountryTemplateForm.vue?vue&type=script&lang=js&"
export * from "./CountryTemplateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports